import { drainQueue } from './idb-queue'

/**
 * bench-QUEUE-DRAINS-ON-RECONNECT.CB-E §1.2 — nothing today drains the queue on an
 * `online` event; a queued offline action sat until the next Cockpit mount, SW background
 * sync (unavailable on iOS Safari) or re-auth. This installs the missing handler.
 *
 * `hop:queue-drained` fires once `drainQueue()` settles, ok or not, so the Cockpit can
 * refresh without reloading regardless of what the drain itself found.
 *
 * bench-QUEUE-TELLS-THE-TRUTH-OFFLINE.CB-E §1.4 — `online` alone was not reaching Dee's
 * phone (either it never fired or wasn't caught). `visibilitychange` back to `'visible'`
 * is a second, independent trigger for the same drain: the app coming back into view
 * drains regardless of what the connectivity event did or didn't do.
 */
export function installDrainOnReconnect(win: Window): () => void {
  const handler = () => {
    void drainQueue().finally(() => {
      win.dispatchEvent(new CustomEvent('hop:queue-drained'))
    })
  }
  const visibilityHandler = () => {
    if (win.document.visibilityState === 'visible') handler()
  }
  win.addEventListener('online', handler)
  win.document.addEventListener('visibilitychange', visibilityHandler)
  return () => {
    win.removeEventListener('online', handler)
    win.document.removeEventListener('visibilitychange', visibilityHandler)
  }
}
